import { render, staticRenderFns } from "./CustomerApply.vue?vue&type=template&id=63b88a76&scoped=true"
import script from "./CustomerApply.vue?vue&type=script&lang=ts"
export * from "./CustomerApply.vue?vue&type=script&lang=ts"
import style0 from "./CustomerApply.vue?vue&type=style&index=0&id=63b88a76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b88a76",
  null
  
)

export default component.exports